module.exports = __webpack_public_path__ + "img/hero5-app.d925fd36.png";